<template>
    <v-carousel v-model="model" interval="1" height="100%">

        <v-carousel-item>
            <v-sheet height="100%" tile>
                <v-row class="fill-height" align="center" justify="center">
                    <v-col cols="12">
                        <DataMap />
                    </v-col>
                </v-row>
            </v-sheet>
        </v-carousel-item>

        <v-carousel-item v-if="isDev">
            <v-sheet height="100%" tile>
                <v-row class="fill-height" align="center" justify="center">
                    <v-col cols="12">
                        <DataMap :heatMap="true" />
                    </v-col>
                </v-row>
            </v-sheet>
        </v-carousel-item>

        <v-carousel-item v-for="device in deviceProject" :key="device">
            <v-sheet height="100%" tile>
                <v-row class="fill-height" align="center" justify="center">
                    <v-col cols="12">
                        <SimpleChars :deviceId="device"></SimpleChars>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-carousel-item>

        <v-carousel-item>
            <v-sheet height="100%" tile>
                <v-row class="fill-height" align="center" justify="center">
                    <v-col cols="12">
                        <SimpleChars :devices="deviceProject"></SimpleChars>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-carousel-item>

    </v-carousel>
</template>

<script>
import moment from 'moment'
import SimpleChars from '@/components/components/SimpleChars'
import DataMap from '@/components/main/DataMap'

export default {
    name: 'Compare',

    data: () => ({
        dialogAddCard: false,
        deviceId: '',
        model: 0,
        timer: null
    }),

    methods: {
        showSlide (index, position) {
            return index === position
        }
    },

    computed: {
        devices () {
            return this.$store.getters.devices
        },

        project () {
            return this.$store.getters.project
        },

        deviceProject () {
            if (this.devices.length === 0)
                return ''

            const initProject = this.devices[0].projectId
            const selectProject = this.project === 'all' ? initProject : this.project

            const devices = this.devices.filter(e => {
                return e.projectId === selectProject
            })

            return devices.map ( e => e.deviceId )
        },

        user() {
            return this.$store.getters.user
        },
        
        isDev() {
            return this.user.roles.some(e => {
                return e.name === 'dev'
            })
        }
    },

    components: {
        SimpleChars,
        DataMap
    },

    created() {
        moment.locale('es-us')

        this.timer = setInterval(() => {
            this.model++

            if (this.model > (this.deviceProject.length + 3))
                this.model = 0

        }, 20000)

    },

    destroyed () {
        clearInterval(this.timer)
    }
}
</script>
